import { render, staticRenderFns } from "./UserJourneyCellRendererActions.vue?vue&type=template&id=52002018&scoped=true&"
import script from "./UserJourneyCellRendererActions.vue?vue&type=script&lang=js&"
export * from "./UserJourneyCellRendererActions.vue?vue&type=script&lang=js&"
import style0 from "./UserJourneyCellRendererActions.vue?vue&type=style&index=0&id=52002018&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52002018",
  null
  
)

export default component.exports